"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Cellphone;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Cellphone(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#231f20;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Contact"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "cellphone"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline",
    className: "cls-1",
    d: "M74.606,92.5H25.394a4.5,4.5,0,0,1-4.5-4.5V12a4.5,4.5,0,0,1,4.5-4.5H74.606a4.5,4.5,0,0,1,4.5,4.5V88A4.5,4.5,0,0,1,74.606,92.5Zm-48.712-5H74.106v-75H25.894ZM65.46,62.005H34.54a4.5,4.5,0,0,1-4.5-4.5V21.021a4.5,4.5,0,0,1,4.5-4.5H65.46a4.5,4.5,0,0,1,4.5,4.5V57.505A4.5,4.5,0,0,1,65.46,62.005Zm-30.42-5H64.96V21.521H35.04ZM50,83.654a8.661,8.661,0,1,1,8.661-8.66A8.67,8.67,0,0,1,50,83.654Zm0-12.321a3.661,3.661,0,1,0,3.661,3.661A3.665,3.665,0,0,0,50,71.333Z"
  }))));
}